import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { selectMatchState, setMatchState } from '../../../store/match';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { confirmPlayerVote } from '../../../api';
import { Delimiter } from '../../atoms/Delimiter';
import voteDotes from '../../../../public/img/voteDotes.svg';
const votingStyle = {
    // padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    backgroundColor: 'transparent',
    boxShadow: '0',
    marginTop: '22px',
};
const VoteContainer = styled.div `
  background: radial-gradient(100.48% 122.16% at 99.03% 98.33%, #356166 14.37%, #2e4245 82.78%);
  box-shadow: 0px 21px 47px rgba(0, 0, 0, 0.31);
  border-radius: 24px;
  overflow: hidden;
  position: absolute;
  padding: 24px;
  top: 50%;
  transform: translateY(-50%);
  right: 146px;
  z-index: 100;
`;
const PlayerContainer = styled.div `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const PlayerImg = styled.img `
  width: 40px;
  height: 40px;
  border-radius: 50%;
  user-select: none;
  object-fit: cover;
`;
const PlayerNick = styled.div `
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;
const PlayerAction = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.8);
`;
const VotingPlayerAction = styled(PlayerAction) `
  color: #2ab2ff;
`;
const VoteContainerImage = styled.img `
  width: 76px;
  height: 63px;
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
`;
const DottedLine = styled.div `
  margin: 3px 0 3px 18px;
  width: 0px;
  height: 18px;
  border-left: 4px dotted black;
`;
const Image = styled.img `
  width: 4px;
  height: 24px;
  flex-shrink: 0;
  margin: 10px 0;
`;
export function VoteTarget({ votingPlayer, player, onClose, vote, resetVote }) {
    var _a;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const currentVoteId = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.voteId) || '';
    useEffect(() => {
        if (vote && player && resetVote) {
            confirmPlayerVote(currentVoteId, player.id)
                .then((response) => {
                dispatch(setMatchState(response));
                onClose === null || onClose === void 0 ? void 0 : onClose(player);
            })
                .catch((err) => errorHandler(err));
            // try {
            //   const response = await confirmPlayerVote(currentVoteId, player.id)
            //   dispatch(setMatchState(response))
            //   onClose?.(player)
            // } catch (err) {
            //   errorHandler(err)
            // }
            resetVote();
        }
    }, [vote, player, onClose, resetVote]);
    return votingPlayer ? (_jsxs(Paper, Object.assign({ sx: votingStyle }, { children: [_jsxs(PlayerContainer, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: (votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player.gameName) || '' })), _jsx(Typography, Object.assign({ sx: { marginTop: '7px' }, variant: "subtitle2" }, { children: "\u041E\u0442\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0439 \u0433\u043E\u043B\u043E\u0441" }))] }), player && player !== votingPlayer && (_jsxs(_Fragment, { children: [_jsx(Image, { src: voteDotes, alt: "voteDotes" }), _jsx(PlayerContainer, { children: _jsxs("div", { children: [_jsx(Typography, Object.assign({ sx: { color: '#CC8181' }, variant: "h4" }, { children: (player === null || player === void 0 ? void 0 : player.player.gameName) || '' })), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "\u041D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E\u0434 \u043F\u0440\u0438\u0446\u0435\u043B\u043E\u043C" }))] }) }), _jsx(Delimiter, { top: "14px" })] }))] }))) : null;
}
